import { IMAGING_FILTER_DATA_REQUEST, IMAGING_FILTER_DATA_SUCCESS, IMAGING_FILTER_DATA_FAILURE, IMAGING_FILTER_DATA_LOADING } from '../../actionTypes';
import {
  IMAGING_CAT_DETAILS_DATA_REQUEST, IMAGING_CAT_DETAILS_DATA_FAILURE, IMAGING_CAT_DETAILS_DATA_LOADING, IMAGING_CAT_DETAILS_DATA_SUCCESS, IMAGING_NET_CAT_DETAILS_DATA_FAILURE
  , IMAGING_NET_CAT_DETAILS_DATA_LOADING, IMAGING_NET_CAT_DETAILS_DATA_REQUEST, IMAGING_NET_CAT_DETAILS_DATA_SUCCESS
} from '../../actionTypes';
import {
  IMAGING_EXPORT_LINK_FAILURE,
  IMAGING_EXPORT_LINK_LOADING,
  IMAGING_EXPORT_LINK_REQUEST,
  IMAGING_EXPORT_LINK_SUCCESS,
  IMAGING_CATEGORY_VIEW_DATA_FAILURE,
  IMAGING_CATEGORY_VIEW_DATA_LOADING,
  IMAGING_CATEGORY_VIEW_DATA_REQUEST,
  IMAGING_CATEGORY_VIEW_DATA_SUCCESS

} from '../../actionTypes';


export const imagingFilterDataRequest = (payload: any) => ({
  type: IMAGING_FILTER_DATA_REQUEST,
  payload,
});

export const imagingFilterDataSuccess = (payload: any) => ({
  type: IMAGING_FILTER_DATA_SUCCESS,
  payload,
});
export const imagingFilterDataError = (payload: any) => ({
  type: IMAGING_FILTER_DATA_FAILURE,
  payload,
});
export const imagingFilterDataLoading = (payload: any) => ({
  type: IMAGING_FILTER_DATA_LOADING,
  payload,
});

export const imagingDetailsDataRequest = (payload: any) => ({
  type: IMAGING_CAT_DETAILS_DATA_REQUEST,
  payload,
});

export const imagingDetailsDataSuccess = (payload: any) => ({
  type: IMAGING_CAT_DETAILS_DATA_SUCCESS,
  payload,
});
export const imagingDetailsDataError = (payload: any) => ({
  type: IMAGING_CAT_DETAILS_DATA_FAILURE,
  payload,
});
export const imagingDetailsDataLoading = (payload: any) => ({
  type: IMAGING_CAT_DETAILS_DATA_LOADING,
  payload,
});

export const imagingNetDetailsDataRequest = (payload: any) => ({
  type: IMAGING_NET_CAT_DETAILS_DATA_REQUEST,
  payload,
});

export const imagingNetDetailsDataSuccess = (payload: any) => ({
  type: IMAGING_NET_CAT_DETAILS_DATA_SUCCESS,
  payload,
});
export const imagingNetDetailsDataError = (payload: any) => ({
  type: IMAGING_NET_CAT_DETAILS_DATA_FAILURE,
  payload,
});
export const imagingNetDetailsDataLoading = (payload: any) => ({
  type: IMAGING_NET_CAT_DETAILS_DATA_LOADING,
  payload,
});

export const imagingDetailsExportRequest = (payload: any) => ({
  type: IMAGING_EXPORT_LINK_REQUEST,
  payload,
});

export const imagingDetailsExportSuccess = (payload: any) => ({
  type: IMAGING_EXPORT_LINK_SUCCESS,
  payload,
});
export const imagingDetailsExportError = (payload: any) => ({
  type: IMAGING_EXPORT_LINK_FAILURE,
  payload,
});
export const imagingDetailsExportLoading = (payload: any) => ({
  type: IMAGING_EXPORT_LINK_LOADING,
  payload,
});

export const imagingCategoryViewRequest = (payload: any) => ({
  type: IMAGING_CATEGORY_VIEW_DATA_REQUEST,
  payload,
});

export const imagingCategoryViewSuccess = (payload: any) => ({
  type: IMAGING_CATEGORY_VIEW_DATA_SUCCESS,
  payload,
});
export const imagingCategoryViewError = (payload: any) => ({
  type: IMAGING_CATEGORY_VIEW_DATA_FAILURE,
  payload,
});
export const imagingCategoryViewLoading = (payload: any) => ({
  type: IMAGING_CATEGORY_VIEW_DATA_LOADING,
  payload,
});